<script>
import { mapActions, mapState } from 'vuex';
import bem from '@/utils/bem';
import EnhanceCards from '@/components/wizards/enhance/Enhance-cards.vue';

const b = bem('digitize-wizard');

const STEP_NAME = {
  uploadType: 'SELECT OPTION STEP',
  shipKit: 'SHIP KIT OPTIONS STEP',
  imageUploader: 'IMAGE UPLOADER STEP',
  imageNotes: 'IMAGE NOTES STEP',
  imageColorization: 'IMAGE COLORIZATION STEP',
  imageUpgrade: 'IMAGE UPGRADE STEP',
  imageOptionPreselect: 'IMAGE OPTION PRESELECT STEP',
  createProducts: 'CREATE PRODUCTS STEP',
  createWizard: 'CREATE WIZARD STEP',
};

export default {
  components: { EnhanceCards },
  data() {
    return {
      selectedStep: null,
      selectedStepIndex: 0,
      STEP_NAME,
    };
  },
  props: {
    productName: {
      type: String,
      required: true,
    },
    products: {
      type: Array,
      required: true,
    },
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      getWizardAction: 'wizards/getWizard',
      getWizardStepsAction: 'wizards/getWizardSteps',
    }),
    selectStep(wizardSteps, index) {
      const section = wizardSteps[index];
      this.selectedStep = {
        ...section,
        orderSections: section?.orderSections.map((item) => ({
          ...item,
          product: this.products.find((itm) => itm.id === item.productId),
        })),
      };
      this.selectedStepIndex = index;
    },
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.wizards.isLoading,
      productWizard: (state) => state.wizards.productWizard,
      wizardSteps: (state) => state.wizards.wizardSteps,
    }),
  },
  mounted() {
    this.getWizardAction(this.productName);
    this.getWizardStepsAction(this.productName);
  },
  watch: {
    wizardSteps: {
      handler(newValue, oldValue) {
        if (oldValue.length === 0 && newValue.length > 0) {
          this.selectStep(newValue, 0);
        }

        if (oldValue.length > 0 && newValue.length > 0) {
          this.selectStep(newValue, this.selectedStepIndex);
        }
      },
      deep: true,
    },
    products(newValue, oldValue) {
      if (oldValue.length === 0 && newValue.length > 0) {
        this.selectedStep = {
          ...this.selectedStep,
          orderSections: (this.selectedStep?.orderSections || []).map((item) => ({
            ...item,
            product: this.products.find((itm) => itm.id === item.productId),
          })),
        };
      }
    },
  },
};
</script>

<template>
  <div :class="b('')">
    <div :class="b('spinner')" v-if="isLoading  && !wizardSteps?.length">
      <a-spin size="large" />
    </div>
    <div :class="b('wrapper')" v-else>
      <span :class="b('step-name')">
        Step name:
        {{STEP_NAME[this.selectedStep?.name] || ''}}
      </span>
      <div :class="b('middle-block')">
        <div
          :class="b('middle-block-wrap')"
          v-if="selectedStep"
        >
          <div :class="b('middle-block-cards')">
            <EnhanceCards
              :selected-step="selectedStep"
              :products="products"
              :productName="productName"
              :size="768"
            />
          </div>
        </div>
        <div :class="b('buttons')">
          <button
            :class="b('button', { back: true })"
            v-if="selectedStepIndex > 0"
            @click="selectStep(wizardSteps, selectedStepIndex - 1)"
          >Back</button>
          <button
            :class="b('button', { next: true })"
            v-if="selectedStepIndex < wizardSteps.length - 1"
            @click="selectStep(wizardSteps, selectedStepIndex + 1)"
          >Next</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./style.scss"></style>
